
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0.1 0 19.3 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.692 1H1.808A.808.808 0 001 1.808v5.25c0 .446.362.807.808.807h15.884a.808.808 0 00.808-.808v-5.25A.808.808 0 0017.692 1z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.749 7.86a3.43 3.43 0 100-6.86 3.43 3.43 0 000 6.86z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.75 5.91a1.476 1.476 0 100-2.953 1.476 1.476 0 000 2.953zM12.527 9.953H6.971c-.492 0-.89.4-.89.892v3.98c0 .492.398.891.89.891h5.556c.493 0 .892-.399.892-.891v-3.98c0-.493-.4-.892-.892-.892zM12.182 7.86H7.318v2.088h4.864V7.859z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.08 12.398s.095 1.274 1.814 1.274h3.917s1.607.03 1.607-1.274","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    